import { useMemo } from 'react'
import styled from 'styled-components'

import { Chip } from 'Components/Chip/Chip'
import { ShowMoreChips } from 'Components/Chip/ShowMoreChips'
import { BenefitProgram } from 'Utils/types/benefitProgram'
import { spacingXXS } from 'Utils/styles/spacing'
import { prop, sortBy } from 'ramda'
import { elfGreen, red } from 'Utils/styles/colors'

const ChipsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${spacingXXS};
  flex-wrap: wrap;
`

const TaxableNote = styled.span<{ taxable: boolean }>`
  color: ${({ taxable }) => (taxable ? elfGreen : red)};
`

type CategoryChipsProps = {
  program: BenefitProgram
  handleToggle?: () => void
  maxChipsShown?: number
  showAll?: boolean
  showTaxability?: boolean
}
export const CategoryChips = ({
  program,
  maxChipsShown = 1,
  showAll = false,
  handleToggle,
  showTaxability = false
}: CategoryChipsProps) => {
  const extraCategoryCount = program.categories.length - maxChipsShown
  const showMoreCategoryButton = !showAll && extraCategoryCount > 0

  const categories = useMemo(() => {
    const categories = sortBy(prop('name'), program.categories) ?? []
    return showMoreCategoryButton ? categories.slice(0, maxChipsShown) : categories
  }, [program, showMoreCategoryButton, maxChipsShown])

  return (
    <ChipsContainer>
      {categories.map((category) => {
        return (
          <Chip key={category.id} text={category.name}>
            {showTaxability ? (
              <TaxableNote taxable={category.taxable}>
                ({category.taxable ? 'taxable' : 'non-taxable'})
              </TaxableNote>
            ) : undefined}
          </Chip>
        )
      })}
      {
        // Button opens modal showing more benefit program info
        showMoreCategoryButton && handleToggle && (
          <ShowMoreChips handleToggle={handleToggle} numExtraChips={extraCategoryCount} />
        )
      }
    </ChipsContainer>
  )
}
